import { StorageSerializers, useSessionStorage } from "@vueuse/core";
import { computed } from "vue";

/**
 * Whether staff are signed in as another person in this tab. The web app keeps the impersonated user under this
 * session-storage key (its impersonation store) and sends it as `X-Switch-User`; shared surfaces read it here to
 * hide what the API refuses while impersonating: revealing or renewing secrets, installing, consenting, sharing,
 * accepting invitations and disconnecting apps.
 */
const IMPERSONATION_STORAGE_KEY = "impersonationUserIdentifier";

const impersonatedUser = useSessionStorage<string | null>(IMPERSONATION_STORAGE_KEY, null, { serializer: StorageSerializers.string });

export const isImpersonating = computed<boolean>(() => impersonatedUser.value !== null);
